import React from "react";
import PropTypes from "prop-types";
import Tippy from '@tippy.js/react';
import {ReactComponent as Warning} from "../../assets/warning.svg";
import styled from "@emotion/styled";
import CircularProgress from "@material-ui/core/CircularProgress";

import {makeStyles} from "@material-ui/core";

import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/material.css';
import 'tippy.js/animations/scale-subtle.css';

const CustomerName = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    padding-right: 25px;
    margin-left: var(--space-s);
    font-weight: 500;
    align-items: center;
    color: ${props => props.mode === "selected" ? "var(--color-blue--600)" : (props.mode === "disabled") ? "var(--font-secondary)" : "var(--color-blue-600)"};
    svg {
      margin-left: var(--space-s);
    }
`;


const ContentWrapper = styled.span`
    display: flex;
    flex-direction: row;
`;


const useStyles = makeStyles(theme => ({
    progress: {
        margin: theme.spacing(1),
    },
}));


export default function CustomerNameTableCell(props) {
    const {customerName, mode, warning, loading, onCustomerNameClick} = props;
    const classes = useStyles();


    return (
        <ContentWrapper>
            {loading && <CircularProgress className={classes.progress} size={15} color="secondary"/>}
            <CustomerName mode={mode}>
                <div onClick={onCustomerNameClick}
                     style={{
                         cursor: "pointer",
                         userSelect: "none",
                     }}>
                    {customerName}
                </div>
                <div>
                    {((warning && warning.length )? warning.length > 0 : false) &&
                    <Tippy
                        content={
                            <>
                                {warning.map((line, index) => {
                                    return <span key={index}>
                                        {line}
                                        <br/>
                                    </span>
                                })}
                            </>
                        }
                        placement="bottom"
                        animation="scale-subtle"
                        theme="material"
                        arrow={false}
                        duration={200}
                        delay={[75, 0]}
                        distance={8}>
                        <Warning/>
                    </Tippy>}
                </div>
            </CustomerName>
        </ContentWrapper>
    )
}

CustomerNameTableCell.propTypes = {
    customerName: PropTypes.string,
    mode: PropTypes.string,
    onCustomerNameClick: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    warning: PropTypes.any
};
